import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Register from '../views/Register.vue'
import Submission from '../views/Submission.vue'
import OrganizerDetail from '@/views/OrganizerDetail.vue'
import AdminLayout from '@/views/admin/AdminLayout.vue'
import AdminRegistrations from '@/views/admin/AdminRegistrations.vue'
import AdminSubmissions from '@/views/admin/AdminSubmissions.vue'
import AdminSpeakers from '@/views/admin/AdminSpeakers.vue'
import AdminSessions from '@/views/admin/AdminSessions.vue'
import AdminSchedules from '@/views/admin/AdminSchedules.vue'
import SpeakerDetail from '@/views/SpeakerDetail.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
  },
  {
    path: '/submission',
    name: 'Submission',
    component: Submission,
  },
  {
    path: '/organizer/:id',
    name: 'OrganizerDetail',
    component: OrganizerDetail,
  },
  {
    path: '/speaker/:id',
    name: 'SpeakerDetail',
    component: SpeakerDetail,
  },
  {
    path: '/admin',
    name: 'Admin',
    component: AdminLayout,
    redirect: '/admin/registrations',
    children: [
      {
        path: 'registrations',
        name: 'AdminRegistrations',
        component: AdminRegistrations,
        meta: {
          title: 'admin.registrations.title'
        }
      },
      {
        path: 'submissions',
        name: 'AdminSubmissions',
        component: AdminSubmissions,
        meta: {
          title: 'admin.submissions.title'
        }
      },
      {
        path: 'speakers',
        name: 'AdminSpeakers',
        component: AdminSpeakers,
        meta: {
          title: 'admin.speakers.title'
        }
      },
      {
        path: 'sessions',
        name: 'AdminSessions',
        component: AdminSessions,
        meta: {
          title: 'Session 管理'
        }
      },
      {
        path: 'schedules',
        name: 'AdminSchedules',
        component: AdminSchedules,
        meta: {
          title: '日程管理'
        }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router